import React from 'react'
import { Empty } from 'antd'
import type { Member, MemberListFilters, MemberTableGroup, Organization } from '../../types'
import MemberGroupHeader from './MemberGroupHeader'
import MemberRow from './MemberRow'
import MemberTableHead from './MemberTableHead'
import MemberTableScroll from './MemberTableScroll'

interface MemberTableProps {
  groups: MemberTableGroup[]
  organizations?: Organization[]
  roleOrganizations?: Organization[]
  showOrganizationFilter?: boolean
  filters?: MemberListFilters
  onFiltersChange?: (filters: MemberListFilters) => void
  currentCustomerId?: string | null
  memberCount?: number
  onInvite: (organization: Organization) => void
  onAssign?: (member: Member, organization: Organization) => void
  onEdit?: (member: Member, organization: Organization) => void
  onDisable?: (member: Member, organization: Organization) => void
  onEnable?: (member: Member, organization: Organization) => void
  onResendInvite?: (member: Member, organization: Organization) => Promise<void>
  onUpgrade?: (organization: Organization) => void
}

const MemberTable: React.FC<MemberTableProps> = ({
  groups,
  organizations,
  roleOrganizations,
  showOrganizationFilter,
  filters,
  onFiltersChange,
  currentCustomerId,
  memberCount,
  onInvite,
  onAssign,
  onEdit,
  onDisable,
  onEnable,
  onResendInvite,
  onUpgrade,
}) => (
  <div className="um-refactor__member-table">
    <div className="um-refactor__table-wrap">
      <MemberTableScroll
        header={(
          <MemberTableHead
            organizations={organizations}
            roleOrganizations={roleOrganizations}
            showOrganizationFilter={showOrganizationFilter}
            filters={filters}
            onFiltersChange={onFiltersChange}
          />
        )}
      >
        {groups.map(({ org, rows }) => (
          <div key={org.id}>
            <MemberGroupHeader
              org={org}
              memberCount={memberCount ?? 0}
              currentCustomerId={currentCustomerId}
              onInvite={onInvite}
              onUpgrade={onUpgrade}
            />
            {rows.map((row, index) => (
              <MemberRow
                key={`${org.id}-${row.member.id || row.member.email}-${index}`}
                row={row}
                organization={org}
                onAssign={onAssign}
                onEdit={onEdit}
                onDisable={onDisable}
                onEnable={onEnable}
                onResendInvite={onResendInvite}
              />
            ))}
            {rows.length === 0 && (
              <div className="um-refactor__empty-row">
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No users found" />
              </div>
            )}
          </div>
        ))}
      </MemberTableScroll>
    </div>
    <div className="um-refactor__footer-note">
      Management view: only organizations where you can manage users are listed here. Roles and permissions stay independent in each organization.
    </div>
  </div>
)

export default MemberTable
